export function chunkArray<T>(arr: T[], size: number): T[][] {
  const result: T[][] = []
  for (let i = 0; i < arr.length; i += size) {
    result.push(arr.slice(i, i + size))
  }
  return result
}

export function toTwoDigits(num: number): string {
  return num.toString().padStart(2, '0')
}

export function splitByIndex<T>(arr: T[], index: number): [T[], T[]] {
  return [arr.slice(0, index), arr.slice(index)]
}
